import React, { Component } from "react";
import CartContext from "./CartContext";
import axios from "axios";
import { Table, Button, Modal, Form, Row, Col, Badge } from "react-bootstrap";

export default class ProjectManagement extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      storeId: "",
      projects: [],
      employees: [],
      statusFilter: "",
      mgrFilter: "",
      showModal: false,
      currentProject: this.getEmptyProject(),
    };
  }

  getEmptyProject = () => ({
    id: "",
    projectName: "",
    projectRequirements: "",
    mgrId: "",
    status: 0,
    plannedStart: "",
    plannedEnd: "",
    actualStart: "",
    actualEnd: "",
    plannedCost: 0,
    actualCost: 0,
  });

  componentDidMount() {
    if (this.context.storeId) {
      this.setState({ storeId: this.context.storeId }, () => {
        this.loadProjects();
        this.fetchEmployees();
      });
    }
  }

  fetchEmployees = () => {
    axios
      .get(
        `${process.env.REACT_APP_API}Employee/GetEmployees/${this.context.storeId}`
      )
      .then((res) => this.setState({ employees: res.data }))
      .catch(() => this.setState({ error: "Failed to load employees." }));
  };

  loadProjects = () => {
    const { storeId, statusFilter, mgrFilter } = this.state;
    if (!storeId) return;

    let url = process.env.REACT_APP_API + `Project/Store/${storeId}`;
    let params = {};
    if (statusFilter) params.status = statusFilter;
    if (mgrFilter) params.mgrId = mgrFilter;

    axios
      .get(url, { params })
      .then((res) => this.setState({ projects: res.data }))
      .catch((err) => console.error(err));
  };

  handleShowModal = (project = null) => {
    if (project) {
      this.setState({ currentProject: { ...project }, showModal: true });
    } else {
      this.setState({
        currentProject: this.getEmptyProject(),
        showModal: true,
      });
    }
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, currentProject: this.getEmptyProject() });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      currentProject: { ...this.state.currentProject, [name]: value },
    });
  };

  handleSave = () => {
    const project = this.state.currentProject;

    if (!project.projectName) {
      alert("Project Name is required");
      return;
    }

    // Build payload explicitly
    const payload = {
      // Only include Id if updating
      ...(project.id && { id: project.id }),
      storeId: this.context.storeId,
      projectName: project.projectName,
      projectRequirements: project.projectRequirements || null,
      mgrId: project.mgrId ? project.mgrId : null,
      status: parseInt(project.status) || 0,
      plannedStart: project.plannedStart
        ? new Date(project.plannedStart).toISOString()
        : null,
      plannedEnd: project.plannedEnd
        ? new Date(project.plannedEnd).toISOString()
        : null,
      actualStart: project.actualStart
        ? new Date(project.actualStart).toISOString()
        : null,
      actualEnd: project.actualEnd
        ? new Date(project.actualEnd).toISOString()
        : null,
      plannedCost: project.plannedCost ? parseFloat(project.plannedCost) : 0,
      actualCost: project.actualCost ? parseFloat(project.actualCost) : 0,
    };

    const selectedManager = this.state.employees.find(
      (e) => e.id.toString() === (project.mgrId?.toString() || "")
    );

    if (project.id) {
      // Update
      axios
        .put(process.env.REACT_APP_API + `Project/${project.id}`, payload)
        .then(() => {
          this.setState((prevState) => ({
            projects: prevState.projects.map((p) =>
              p.id === project.id ? { ...payload, mgr: selectedManager } : p
            ),
            showModal: false,
          }));
        })
        .catch((err) => console.error(err));
    } else {
      // Create
      axios
        .post(process.env.REACT_APP_API + "Project", payload)
        .then((res) => {
          const newProject = res.data;
          newProject.mgr = selectedManager;
          this.setState((prevState) => ({
            projects: [...prevState.projects, newProject],
            showModal: false,
          }));
        })
        .catch((err) => {
          alert(err);
        });
    }
  };

  handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this project?")) {
      axios
        .delete(process.env.REACT_APP_API + `Project/${id}`)
        .then(() => this.loadProjects())
        .catch((err) => console.error(err));
    }
  };

  handleFilterChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, this.loadProjects);
  };

  render() {
    const {
      projects,
      showModal,
      currentProject,
      employees,
      statusFilter,
      mgrFilter,
    } = this.state;
    const statusText = ["Planned", "In Progress", "Completed", "On Hold"];
    const statusBadge = (status) => {
      switch (status) {
        case 0:
          return <Badge bg="secondary">{statusText[0]}</Badge>;
        case 1:
          return <Badge bg="primary">{statusText[1]}</Badge>;
        case 2:
          return <Badge bg="success">{statusText[2]}</Badge>;
        case 3:
          return (
            <Badge bg="warning" text="dark">
              {statusText[3]}
            </Badge>
          );
        default:
          return <Badge bg="secondary">Unknown</Badge>;
      }
    };

    return (
      <div className="container mt-1">
        <h3>
          <b>Projects</b>
        </h3>

        <Row className="mb-3 mt-3">
          <Col md={3}>
            <Form.Select
              name="statusFilter"
              value={statusFilter}
              onChange={this.handleFilterChange}
            >
              <option value="">-- Filter by Status --</option>
              <option value="0">Planned</option>
              <option value="1">In Progress</option>
              <option value="2">Completed</option>
              <option value="3">On Hold</option>
            </Form.Select>
          </Col>
          <Col md={3}>
            <Form.Select
              name="mgrFilter"
              value={mgrFilter}
              onChange={this.handleFilterChange}
            >
              <option value="">-- Filter by Manager --</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.firstName} {emp.lastName}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={3}>
            <Button
              variant="primary"
              disabled={
                this.state.projects.length >=
                  this.context.storeSettings.totalProjects ?? 3
              }
              onClick={() => this.handleShowModal()}
            >
              Add Project
            </Button>
          </Col>
        </Row>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Requirements</th>
              <th>Manager</th>
              <th>Status</th>
              <th>Planned Start</th>
              <th>Planned End</th>
              <th>Actual Start</th>
              <th>Actual End</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((p) => (
              <tr key={p.id}>
                <td>{p.projectName}</td>
                <td>{p.projectRequirements}</td>
                <td>
                  {p.mgr?.firstName} {p.mgr?.lastName}
                </td>
                <td>{statusBadge(p.status)}</td>
                <td>
                  {p.plannedStart
                    ? new Date(p.plannedStart).toLocaleDateString()
                    : ""}
                </td>
                <td>
                  {p.plannedEnd
                    ? new Date(p.plannedEnd).toLocaleDateString()
                    : ""}
                </td>
                <td>
                  {p.actualStart
                    ? new Date(p.actualStart).toLocaleDateString()
                    : ""}
                </td>
                <td>
                  {p.actualEnd
                    ? new Date(p.actualEnd).toLocaleDateString()
                    : ""}
                </td>
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => this.handleShowModal(p)}
                  >
                    Edit
                  </Button>{" "}
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => this.handleDelete(p.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {currentProject.id ? "Edit Project" : "Add Project"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(e) => e.preventDefault()}>
              <Form.Group className="mb-3">
                <Form.Label>Project Name</Form.Label>
                <Form.Control
                  name="projectName"
                  value={currentProject.projectName || ""}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Requirements</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={10}
                  name="projectRequirements"
                  value={currentProject.projectRequirements || ""}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Manager</Form.Label>
                <Form.Select
                  name="mgrId"
                  value={currentProject.mgrId || ""}
                  onChange={this.handleChange}
                >
                  <option value="">-- Select Manager --</option>
                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.firstName} {emp.lastName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="status"
                  value={currentProject.status || 0}
                  onChange={this.handleChange}
                >
                  <option value="0">Planned</option>
                  <option value="1">In Progress</option>
                  <option value="2">Completed</option>
                  <option value="3">On Hold</option>
                </Form.Select>
              </Form.Group>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Planned Start</Form.Label>
                    <Form.Control
                      type="date"
                      name="plannedStart"
                      value={currentProject.plannedStart?.split("T")[0] || ""}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Planned End</Form.Label>
                    <Form.Control
                      type="date"
                      name="plannedEnd"
                      value={currentProject.plannedEnd?.split("T")[0] || ""}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Actual Start</Form.Label>
                    <Form.Control
                      type="date"
                      name="actualStart"
                      value={currentProject.actualStart?.split("T")[0] || ""}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Actual End</Form.Label>
                    <Form.Control
                      type="date"
                      name="actualEnd"
                      value={currentProject.actualEnd?.split("T")[0] || ""}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Planned Cost</Form.Label>
                    <Form.Control
                      type="number"
                      name="plannedCost"
                      value={currentProject.plannedCost || 0}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Actual Cost</Form.Label>
                    <Form.Control
                      type="number"
                      name="actualCost"
                      value={currentProject.actualCost || 0}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              type="button"
              onClick={this.handleCloseModal}
            >
              Cancel
            </Button>
            <Button variant="primary" type="button" onClick={this.handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
